import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useHydratedWindowDimensions } from '../../hooks/useHydratedWindowDimensions';
import colors from '../../lib/colors';
import { interSemiBold } from '../../lib/fonts';
import { Body, Heading, Section, SectionLabel } from '../about/AboutPrimitives';
import BriefConversation from '../researchBriefs/BriefConversation';
import { Trans } from '@lingui/react/macro';

export default function HomeResearchBrief({ fontsLoaded }: { fontsLoaded: boolean }) {
    const { width } = useHydratedWindowDimensions();
    const isNarrow = width < 760;
    const isStacked = width < 980;

    return (
        <Section nativeID="morning-brief" top={88} bottom={88} isNarrow={isNarrow}>
            <View style={[styles.split, isStacked && styles.splitStacked]}>
                <View style={[styles.copy, isStacked && styles.columnStacked]}>
                    <SectionLabel fontsLoaded={fontsLoaded}><Trans id="home.homeresearchbrief.morningResearchBriefs" comment="UI copy in components/home/HomeResearchBrief.tsx">Morning research briefs</Trans></SectionLabel>
                    <Heading fontsLoaded={fontsLoaded}><Trans id="home.homeresearchbrief.aResearchBriefYouCanTalkTo" comment="UI copy in components/home/HomeResearchBrief.tsx">
                        A research brief you can talk to.
                    </Trans></Heading>
                    <Body fontsLoaded={fontsLoaded}><Trans id="home.homeresearchbrief.connectPaperzillaToYourAiAssistant" comment="UI copy in components/home/HomeResearchBrief.tsx">
                        Connect Paperzilla to your AI assistant. Every morning it reads what’s new in your feeds, tells you which papers are worth your time and why, and answers your follow-up questions from the papers themselves.
                    </Trans></Body>
                    <Text style={[styles.assistants, fontsLoaded && interSemiBold]}><Trans id="home.homeresearchbrief.worksWithClaudeChatGptAndAnyAiAssistantThatSupportsMcp" comment="UI copy in components/home/HomeResearchBrief.tsx. Preserve product names and MCP.">
                        Works with Claude, ChatGPT, and any AI assistant that supports MCP.
                    </Trans></Text>
                </View>
                <View style={[styles.aside, isStacked && styles.columnStacked]}>
                    <BriefConversation fontsLoaded={fontsLoaded} />
                </View>
            </View>
        </Section>
    );
}

const styles = StyleSheet.create({
    split: {
        alignItems: 'center',
        flexDirection: 'row',
        gap: 56,
    },
    splitStacked: {
        alignItems: 'stretch',
        flexDirection: 'column',
        gap: 40,
    },
    copy: {
        flex: 0.9,
        minWidth: 0,
    },
    aside: {
        flex: 1.1,
        minWidth: 0,
    },
    // Column flex ratios would split the stacked height between copy and card.
    columnStacked: {
        flexBasis: 'auto',
        flexGrow: 0,
    },
    assistants: {
        color: colors.primaryGreenDark,
        fontSize: 14,
        fontWeight: '600',
        lineHeight: 21,
        marginTop: 18,
    },
});
